var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCut = function SvgCut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cut_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cut_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 14-2.35 2.35q.2.375.275.8T10 18q0 1.65-1.175 2.825T6 22t-2.825-1.175T2 18t1.175-2.825T6 14q.425 0 .85.075t.8.275L10 12 7.65 9.65q-.375.2-.8.275T6 10q-1.65 0-2.825-1.175T2 6t1.175-2.825T6 2t2.825 1.175T10 6q0 .425-.075.85t-.275.8L20.6 18.6q.675.675.3 1.537-.375.863-1.325.863-.275 0-.537-.113a1.5 1.5 0 0 1-.463-.312zm3-3-2-2 5.575-5.575q.2-.2.463-.312Q19.3 3 19.575 3q.949 0 1.313.875.362.875-.313 1.55zM6 8q.824 0 1.412-.588Q8 6.826 8 6q0-.824-.588-1.412A1.93 1.93 0 0 0 6 4q-.824 0-1.412.588A1.93 1.93 0 0 0 4 6q0 .824.588 1.412Q5.175 8 6 8m6 4.5a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7q.15.15.35.15M6 20q.824 0 1.412-.587Q8 18.825 8 18q0-.824-.588-1.413A1.93 1.93 0 0 0 6 16q-.824 0-1.412.587A1.93 1.93 0 0 0 4 18q0 .824.588 1.413Q5.175 20 6 20"
  }))));
};
export default SvgCut;